import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('BookingSubCategoryStore')
@observer
class BookingSubCategorySearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Category',
                dataIndex: 'name',
                key: 'name',
                width: '80%'
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'id',
                width: '20%',
                render: id => (
                    <span>
                        <Button onClick={() => this.selectBookingCategoryOnClick(id)} type='primary'>
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    itemOnChange = e => {
        this.props.BookingSubCategoryStore.setBookingCategorySearchValue(e.target.value);
        this.props.BookingSubCategoryStore.searchBookingCategory();
    }

    // ON CLICK

    selectBookingCategoryOnClick = taskId => {
        this.props.BookingSubCategoryStore.searchBookingCategorySelected(taskId);
        this.props.BookingSubCategoryStore.setShowBookingCategorySearchModal(false);
    }

    render() {
        const {
            lastChildBookingCategoryFilter,
            bookingCategorySearchValue
        } = this.props.BookingSubCategoryStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Retail' value={bookingCategorySearchValue} onChange={this.itemOnChange} />
                <Table columns={this.getColumns()} dataSource={lastChildBookingCategoryFilter} />
            </React.Fragment>
        )
    }
}

export default BookingSubCategorySearchModalPage;
